import React, { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { recordZ4RumError } from '@marageti/z4-lib';
import DefaultError from './DefaultError';
// React Router Dom recommends to replace the default error element to be returned.
// https://reactrouter.com/en/main/route/error-element#default-error-element
const ErrorBoundaryRouter = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error instanceof Error) {
      recordZ4RumError(error, { source: 'ErrorBoundaryRouter' });
    } else if (error != null) {
      recordZ4RumError(new Error(String(error)), { source: 'ErrorBoundaryRouter' });
    }
  }, [error]);

  return <DefaultError />;
};

export default ErrorBoundaryRouter;
